module.exports = __webpack_public_path__ + "static/media/mail-verification.01493843.gif";